import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "nav-bar sticky is-hidden-below-small" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 2 }

import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from 'vuex'
import { useGettext } from 'vue3-gettext'
import { useAdvanceStore } from '@/store'
import { getCookie } from '@/helpers/getCookie'


export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationBar',
  setup(__props) {

const { $gettext } = useGettext()
const { getters } = useStore()
const { advanceTransactions } = storeToRefs(useAdvanceStore())
const isOnProPlanOrAbove = computed(() => getters.isOnProPlanOrAbove)
const DittoDashboardUrl = process.env.VUE_APP_DASHBOARD_URL
const SalesUiUrl = process.env.VUE_APP_SALES_UI_URL
const ReportsUrl = process.env.VUE_APP_REPORTS_UI_URL
const hasAdvances = !!Number(getCookie('DittoMusic[hasAdvances]'))
const hasCollaborations = !!Number(getCookie('DittoMusic[hasCollaborations]'))

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            href: `${_unref(SalesUiUrl)}/sales-area/sales`
          }, _toDisplayString(_unref($gettext)('Sales')), 9, _hoisted_3)
        ]),
        hasCollaborations
          ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
              _createElementVNode("a", {
                href: `${_unref(DittoDashboardUrl)}/sales/collaborations`
              }, _toDisplayString(_unref($gettext)('Collaborations')), 9, _hoisted_5)
            ]))
          : _createCommentVNode("", true),
        (isOnProPlanOrAbove.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
              _createElementVNode("a", {
                href: `${_unref(ReportsUrl)}/reports`
              }, _toDisplayString(_unref($gettext)('Reports')), 9, _hoisted_7)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, { to: "/" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref($gettext)('Payouts')), 1)
            ]),
            _: 1
          })
        ]),
        (hasAdvances || _unref(advanceTransactions).length)
          ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
              _createVNode(_component_RouterLink, { to: "/advances" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($gettext)('Advances')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})